import { LivePassSignupCard } from "@/components/LivePassSignupCard";

/** Versión mínima para pegar dentro de un `iframe` en el sitio de la escuela:
 *  solo la tarjeta de registro, sin portada ni calendario. El código de 6
 *  dígitos se digita acá mismo, sin salir del sitio de la escuela. */
export default function LiveEmbed() {
  // Permite volver directo al paso del código (?step=code&email=...) si la
  // persona recargó la página antes de digitarlo.
  const query = new URLSearchParams(window.location.search);
  const enCodigo = query.get("step") === "code";

  return (
    <div className="min-h-[560px] bg-transparent p-3" data-testid="live-embed">
      <div className="max-w-md mx-auto bg-white border border-slate-200 rounded-2xl p-6 shadow-sm">
        <LivePassSignupCard
          source="wss_live_embed"
          escapeOnDone
          initialEmail={query.get("email") || ""}
          initialDone={enCodigo}
        />
      </div>
    </div>
  );
}
